/* Shared Asai product card behaviour: colour swatch -> variant, and add to cart via the theme mini-cart. */
(function () {
  if (window.zfCardBound) return;
  window.zfCardBound = true;

  /* ---- Swatch images: preload so a colour tap swaps the photo instantly ----
     The photo URL is re-sized to what this screen actually needs (same widths as the card's srcset),
     fetched + decoded ahead of time, and cached, so the tap never waits on the network. */
  var WIDTHS = [360, 540, 720, 900];
  var cache = {};
  function sizedUrl(url, el) {
    if (!url) return '';
    var need = Math.ceil(((el && el.clientWidth) || 180) * Math.min(window.devicePixelRatio || 1, 3));
    var w = WIDTHS[WIDTHS.length - 1];
    for (var i = 0; i < WIDTHS.length; i++) { if (WIDTHS[i] >= need) { w = WIDTHS[i]; break; } }
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function load(url) {
    if (!url) return Promise.resolve();
    if (!cache[url]) {
      cache[url] = new Promise(function (res) {
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(res, res); };
        im.onerror = function () { delete cache[url]; res(); };
        im.src = url;
      });
    }
    return cache[url];
  }
  function preloadCard(item, withSecond) {
    var img = item.querySelector('[data-zf-img]'), img2 = item.querySelector('[data-zf-img2]');
    item.querySelectorAll('[data-zf-sw]').forEach(function (b) {
      load(sizedUrl(b.dataset.img, img));
      if (withSecond && b.dataset.img2) load(sizedUrl(b.dataset.img2, img2 || img));
    });
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  function watchCards(root) {
    var items = (root || document).querySelectorAll('.zf [data-zf-item]:not([data-zf-pre])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) { items.forEach(function (it) { it.setAttribute('data-zf-pre', ''); idle(function () { preloadCard(it); }); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        idle(function () { preloadCard(e.target); });
      });
    }, { rootMargin: '400px 0px' });
    items.forEach(function (it) { if (!it.querySelector('[data-zf-sw]')) return; it.setAttribute('data-zf-pre', ''); io.observe(it); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watchCards(); }); else watchCards();
  document.addEventListener('shopify:section:load', function (e) { watchCards(e.target); });
  /* A finger landing on a swatch starts the fetch ~100ms before the click fires. */
  document.addEventListener('pointerdown', function (e) {
    var sw = e.target.closest && e.target.closest('.zf [data-zf-sw]');
    if (!sw) return;
    var item = sw.closest('[data-zf-item]');
    load(sizedUrl(sw.dataset.img, item.querySelector('[data-zf-img]')));
  }, { passive: true });

  function swapImg(el, url) {
    if (!el) return;
    if (!url) return;
    el.dataset.want = url;
    var p = load(url), done = false;
    p.then(function () {
      done = true;
      if (el.dataset.want !== url) return;   /* a newer tap won */
      el.removeAttribute('srcset');
      el.src = url;
      el.classList.remove('is-loading');
    });
    /* Only if it is genuinely still downloading, dim the old photo so the tap feels acknowledged. */
    setTimeout(function () { if (!done && el.dataset.want === url) el.classList.add('is-loading'); }, 60);
  }

  /* Swatch → variant: prices, badge and button update at once; the photo swaps as soon as it is decoded. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.zf [data-zf-sw]');
    if (!sw || sw.disabled) return;
    var item = sw.closest('[data-zf-item]');
    item.querySelectorAll('[data-zf-sw]').forEach(function (b) {
      b.classList.toggle('is-active', b === sw);
      b.setAttribute('aria-pressed', b === sw ? 'true' : 'false');
    });
    var d = sw.dataset;
    var img = item.querySelector('[data-zf-img]');
    swapImg(img, sizedUrl(d.img, img));
    var img2 = item.querySelector('[data-zf-img2]');
    if (img2) {
      var slide2 = img2.closest('.zf-gal__slide');
      if (d.img2) { swapImg(img2, sizedUrl(d.img2, img2.clientWidth ? img2 : img)); slide2.hidden = false; } else { slide2.hidden = true; }
      var bar = item.querySelector('.zf-gal__bar'); if (bar) bar.hidden = !d.img2;
    }
    var gal = item.querySelector('[data-zf-gal]'); if (gal) gal.scrollLeft = 0;
    item.querySelectorAll('[data-zf-link]').forEach(function (a) { a.href = d.url; });
    var now = item.querySelector('[data-zf-now]'); if (now) now.textContent = d.price;
    var was = item.querySelector('[data-zf-was]'); if (was) was.textContent = d.compare || '';
    var off = item.querySelector('[data-zf-off]');
    if (off) { off.textContent = d.off ? d.off + '% OFF' : ''; off.hidden = !d.off; }
    var atc = item.querySelector('[data-zf-atc]');
    atc.dataset.variant = d.variant;
    atc.disabled = d.available !== 'true';
    atc.textContent = d.available === 'true' ? atc.dataset.label : atc.dataset.soldout;
    /* The shopper is exploring this card: warm the other colours' second photos too. */
    if (!item.hasAttribute('data-zf-pre2')) { item.setAttribute('data-zf-pre2', ''); idle(function () { preloadCard(item, true); }); }
  });

  /* Card gallery: move the thin progress bar with the swipe. */
  /* The bar follows the finger 1:1 (no easing, updated once per frame) so it glides with the swipe. */
  var galQueue = [], galTick = false;
  function paintBars() {
    galTick = false;
    galQueue.splice(0).forEach(function (t) {
      var max = t.scrollWidth - t.clientWidth;
      var bar = t.parentNode.querySelector('[data-zf-bar]');
      var p = max > 0 ? Math.min(1, Math.max(0, t.scrollLeft / max)) : 0;
      if (bar) bar.style.setProperty('--p', p);
      /* Hide the rating while the shopper is looking past the first photo. */
      t.parentNode.classList.toggle('is-swiped', p > 0.04);
    });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('.zf [data-zf-gal]')) return;
    if (galQueue.indexOf(t) < 0) galQueue.push(t);
    if (!galTick) { galTick = true; requestAnimationFrame(paintBars); }
  }, true);

  /* Add to cart through the theme's mini-cart, same flow as product-form.js. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.zf [data-zf-atc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;   /* ignore double taps */
    var cart = document.querySelector('mini-cart');
    var fd = new FormData();
    fd.append('id', btn.dataset.variant);
    fd.append('quantity', 1);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    btn.setAttribute('aria-busy', 'true');
    var url = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    /* During sale traffic Shopify can answer 429 (slow down) or a 5xx: wait a moment and try again, up to twice. */
    function post(tries) {
      return fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) {
          if ((r.status === 429 || r.status >= 500) && tries > 0) {
            return new Promise(function (ok) { setTimeout(ok, (3 - tries) * 700 + 400); }).then(function () { return post(tries - 1); });
          }
          return r.json();
        });
    }
    post(2)
      .then(function (res) {
        if (res.status) { alert(res.description || res.message || 'Could not add to cart'); return; }
        if (!cart || !cart.renderContents) { window.location = (window.theme && theme.routes && theme.routes.cart_url) || '/cart'; return; }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zerofest', productVariantId: btn.dataset.variant, cartData: res });
        }
        cart.renderContents(res);
        cart.classList.remove('is-empty');
      })
      .catch(function (err) { console.error(err); window.location = '/cart'; })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
})();
